import React from 'react';

import {ScoresListHeaderModuleProps} from "../models/scores-list-header-module.props";
import {ScoresListHeaderModuleController} from "../scores-list-header-module.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {ScoresListHeaderModuleMobile} from "./mobile/scores-list-header-module.mobile";
import {ScoresHeader} from "../../../core/components/scores-header/scores-header";
import {ScoresHeaderLive} from "../../../core/components/scores-header/scores-header.live";
import {ScoresListHeaderModuleDesktopDater} from "./desktop/scores-list-header-module.desktop.dater";
import {ScoresHeaderOdds} from "../../../core/components/scores-header/scores-header.odds";
import {ODDS_TYPES} from "../../../core/components/odds/components/odds-consts";
import {ACTION_TYPES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";

export class ScoresHeaderModuleComponentProps extends ScoresListHeaderModuleProps {}

export const ScoresHeaderModuleComponent = (({controller, ...props}: ScoresHeaderModuleComponentProps) => {
  const {state} = controller;
  const {device} = state;
  const headerProps = {
    SmallCellContent: props.toRenderLiveSwitch ? ScoresHeaderLive : () => <div/>,
    MediumCellContent: ScoresListHeaderModuleDesktopDater,
    LargeCellContent: ScoresHeaderOdds,
    isLive: state.isLive,
    selectedOddsType: state.selectedOddsType,
    showOdds: state.showOdds,
    onOddsChange: (oddsType: ODDS_TYPES) => controller.action(ACTION_TYPES.oddsChange, {oddsType}),
    onToggleOdds: () => controller.action(ACTION_TYPES.toggleShowOdds,{
      isActive: state.showOdds,
      source: APP.ANALYTICS.SOURCES.scores
    }),
    containerClassName: 'header-date-selector-date-container',
    controller,
    ...props,
  };

  return (
    <div className={'scores-list-header-module'}>
      {
        device.isLargeView ? <ScoresHeader {...headerProps} /> :
          <ScoresListHeaderModuleMobile controller={controller} onDateChange={props.onDateChange}/>
      }
    </div>
  );
});

const settings: ComposeSettings = {
  component: ScoresHeaderModuleComponent,
  propsType: ScoresHeaderModuleComponentProps,
  controllerType: ScoresListHeaderModuleController,

  observe: true,
  createModule: true,
};

export const ScoresListHeaderModule = Compose(settings);
